"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSessionUpdateDto = instanceOfOrientationSessionUpdateDto;
exports.OrientationSessionUpdateDtoFromJSON = OrientationSessionUpdateDtoFromJSON;
exports.OrientationSessionUpdateDtoFromJSONTyped = OrientationSessionUpdateDtoFromJSONTyped;
exports.OrientationSessionUpdateDtoToJSON = OrientationSessionUpdateDtoToJSON;
exports.OrientationSessionUpdateDtoToJSONTyped = OrientationSessionUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSessionUpdateDto interface.
 */
function instanceOfOrientationSessionUpdateDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function OrientationSessionUpdateDtoFromJSON(json) {
    return OrientationSessionUpdateDtoFromJSONTyped(json, false);
}
function OrientationSessionUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'id': json['id'] == null ? undefined : json['id'],
    };
}
function OrientationSessionUpdateDtoToJSON(json) {
    return OrientationSessionUpdateDtoToJSONTyped(json, false);
}
function OrientationSessionUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'id': value['id'],
    };
}
//# sourceMappingURL=OrientationSessionUpdateDto.js.map